__turbopack_context__.v({
  "subtitle": "VebinarSlider-module-scss-module__ut02lW__subtitle",
  "title": "VebinarSlider-module-scss-module__ut02lW__title",
  "titleContainer": "VebinarSlider-module-scss-module__ut02lW__titleContainer",
});
